import {lazy} from 'react';
import AccessProtected from 'lib/RouteProtection';

const OrganizationList = lazy(() => import('./OrganizationList'));
const ApkList = lazy(() => import('./ApkDistribution/ApkList'));
const CreateApk = lazy(() => import('./ApkDistribution/CreateApk'));
const OfficeSetup = lazy(() => import('./OfficeSetup'));
const DeviceManagement = lazy(() => import('./DeviceManagement'));

export const organizationManagerConfig = [
  {
    path: '/organization-manager/settings',
    element: (
      <AccessProtected>
        <OrganizationList />
      </AccessProtected>
    ),
  },
  {
    path: '/organization-manager/apk-list',
    element: (
      <AccessProtected>
        <ApkList />
      </AccessProtected>
    ),
  },
  {
    path: '/organization-manager/create-apk',
    element: (
      <AccessProtected>
        <CreateApk />
      </AccessProtected>
    ),
  },
  {
    path: '/organization-manager/office-setup',
    element: (
      <AccessProtected>
        <OfficeSetup />
      </AccessProtected>
    ),
  },
  {
    path: '/organization-manager/device-management',
    element: (
      <AccessProtected>
        <DeviceManagement />
      </AccessProtected>
    ),
  },
];
